export default {
	type: 'object',
	properties: {
		isAlertsActive: { type: 'boolean' },
	},
}
